import { useContext, useEffect, useState } from "react"
import { requestFaqs } from "../requests/setup_requests"
import { AccountContext } from "../contexts/AccountContexts"
import { useTranslation } from "react-i18next"
import { componentLoadingActive, ComponentLoadingScreen } from "./Background"


export const FAQHomePage = () => {
    const { t } = useTranslation("common")
    const { language } = useContext(AccountContext)

    const [faqs, setFaqs] = useState([])


    useEffect(() => {
        componentLoadingActive(true, "faq-home-loading")
        requestFaqs({})
            .then((data) => {
                setFaqs(data.faqs)
            })
            .catch((error) => {
                console.error(error.status, error.message)
            })
            .finally(() => {
                componentLoadingActive(false, "faq-home-loading")
            })
    }, [])

    const urlRegex = /(https?:\/\/[^\s]+)/g;

    return (
        <div className="flex flex-col gap-2 max-w-[500px] text-gray-800 dark:text-gray-300">
            <ComponentLoadingScreen tag={'faq-home-loading'} />
            {
                faqs?.length > 0 &&
                <>
                    <span className="text-lg pb-2">{t("Frequently Asked Questions")}</span>
                    {
                        faqs.map((faq, index) =>
                            index < 5 &&
                            <div key={faq.id} className="collapse collapse-plus bg-white dark:bg-gray-700">
                                <input type="checkbox" />
                                <div className="collapse-title text-md font-medium">{language === "tr" ? faq.title : faq.engTitle}</div>
                                <div className="collapse-content text-sm whitespace-pre-wrap text-wrap">
                                    {
                                        language === "tr" ?
                                            faq.message.split(urlRegex).map((part, index) =>
                                                urlRegex.test(part) ? (
                                                    <a
                                                        key={index}
                                                        href={part}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="text-blue-500 hover:underline"
                                                    >
                                                        {part}
                                                    </a>
                                                ) : (
                                                    <span key={index}>{part}</span>
                                                )
                                            )
                                            :
                                            faq.engMessage.split(urlRegex).map((part, index) =>
                                                urlRegex.test(part) ? (
                                                    <a
                                                        key={index}
                                                        href={part}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="text-blue-500 hover:underline"
                                                    >
                                                        {part}
                                                    </a>
                                                ) : (
                                                    <span key={index}>{part}</span>
                                                )
                                            )
                                    }
                                </div>
                            </div>
                        )
                    }
                </>
            }
        </div >
    )
}


export const FAQNoLoginHome = () => {
    const { t } = useTranslation("common")
    const { language } = useContext(AccountContext)

    const [faqs, setFaqs] = useState([])


    useEffect(() => {
        componentLoadingActive(true, "faq-home-loading")
        requestFaqs({})
            .then((data) => {
                setFaqs(data.faqs)
            })
            .catch((error) => {
                console.error(error.status, error.message)
            })
            .finally(() => {
                componentLoadingActive(false, "faq-home-loading")
            })
    }, [])

    const urlRegex = /(https?:\/\/[^\s]+)/g;
    
    return (
        <div className="flex flex-col gap-2 max-w-[500px] text-gray-800 dark:text-gray-300">
            <ComponentLoadingScreen tag={'faq-home-loading'} />
            {
                faqs?.length > 0 &&
                <>
                    <span className="text-lg pb-2 text-center font-semibold">{t("Frequently Asked Questions")}</span>
                    {
                        faqs.map((faq, index) =>
                            index < 5 &&
                            <div key={faq.id} className="collapse collapse-plus bg-white dark:bg-gray-800">
                                <input type="checkbox" />
                                <div className="collapse-title text-md font-medium">{language === "tr" ? faq.title : faq.engTitle}</div>
                                <div className="collapse-content text-sm whitespace-pre-wrap text-wrap">
                                    {/* <span>{language === "tr" ? faq.message : faq.engMessage}</span> */}
                                    {
                                        language === "tr" ?
                                            faq.message.split(urlRegex).map((part, index) =>
                                                urlRegex.test(part) ? (
                                                    <a
                                                        key={index}
                                                        href={part}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="text-blue-500 hover:underline"
                                                    >
                                                        {part}
                                                    </a>
                                                ) : (
                                                    <span key={index}>{part}</span>
                                                )
                                            )
                                            :
                                            faq.engMessage.split(urlRegex).map((part, index) =>
                                                urlRegex.test(part) ? (
                                                    <a
                                                        key={index}
                                                        href={part}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="text-blue-500 hover:underline"
                                                    >
                                                        {part}
                                                    </a>
                                                ) : (
                                                    <span key={index}>{part}</span>
                                                )
                                            )
                                    }
                                </div>
                            </div>
                        )
                    }
                </>
            }
        </div>
    )
}